/**
 * Shows/hides variant-scoped sections when the shopper changes variant.
 *
 * Shopify templates bind to a product, not a variant, so a "page per variant"
 * is built by rendering every variant's sections and revealing the matching
 * set. The server picks the initial set (see snippets/repaiir-variant-scope
 * .liquid); this syncs on load and on every switch, using the theme's own
 * `variantChangeEnd` event from assets/variants.js.
 */
(function () {
  if (window.__repaiirVariantScope) return;
  window.__repaiirVariantScope = true;

  var ATTR = 'data-repaiir-variant';
  var HIDDEN = 'data-repaiir-variant-hidden';
  var UNRESOLVED = 'data-repaiir-variant-unresolved';

  function scopedElements() {
    return Array.prototype.slice.call(document.querySelectorAll('[' + ATTR + ']'));
  }

  function apply(variantId) {
    if (!variantId) return;
    var id = String(variantId);

    scopedElements().forEach(function (el) {
      var raw = el.getAttribute(ATTR);
      var ids = raw
        .split(',')
        .map(function (value) {
          return value.trim();
        })
        .filter(function (value) {
          return value && value !== 'none';
        });

      // No usable ids: either unscoped, or a scope that matched nothing. An
      // unresolved scope stays hidden so a typo can't render every variant's
      // content on one page.
      if (!ids.length) {
        if (!el.hasAttribute(UNRESOLVED)) el.removeAttribute(HIDDEN);
        return;
      }

      if (ids.indexOf(id) !== -1) {
        el.removeAttribute(HIDDEN);
      } else {
        el.setAttribute(HIDDEN, 'true');
      }
    });
  }

  function picker() {
    return document.querySelector('variant-selects, variant-radios');
  }

  function currentVariantId() {
    var el = picker();
    if (el && el.currentVariant && el.currentVariant.id) return el.currentVariant.id;

    // Fall back to ?variant= so a shared link lands on the right set even if the
    // picker has not finished upgrading yet.
    var fromUrl = new URLSearchParams(window.location.search).get('variant');
    return fromUrl || null;
  }

  function debugging() {
    return (
      (window.Shopify && window.Shopify.designMode) ||
      new URLSearchParams(window.location.search).has('repaiir-debug')
    );
  }

  /**
   * The server rendered the default variant's set. If the picker settles on a
   * different variant (preselection, a sold-out default, ?variant= handling),
   * re-sync so the two never disagree.
   */
  function sync() {
    var id = currentVariantId();
    apply(id);

    if (!debugging()) return;

    var scoped = scopedElements();
    if (!scoped.length) return;

    var visible = scoped.filter(function (el) {
      return !el.hasAttribute(HIDDEN);
    });

    // Every scoped section hidden means no set is bound to this variant, so the
    // page renders with only the shared sections.
    if (!visible.length) {
      console.warn(
        '[REPAIIR variant scope] No section is scoped to variant ' +
          id +
          ', so none of the A+ content is showing. Scoped values found: ' +
          scoped
            .map(function (el) {
              return el.getAttribute(ATTR);
            })
            .join(' | '),
      );
    }
  }

  window.addEventListener('variantChangeEnd', function (event) {
    var variant = event.target && event.target.currentVariant;
    apply(variant && variant.id ? variant.id : currentVariantId());
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  // Custom elements upgrade after parse, so check once more on load.
  window.addEventListener('load', sync);

  if (window.Shopify && window.Shopify.designMode) {
    scopedElements().forEach(function (el) {
      var bad = el.getAttribute(UNRESOLVED);
      if (bad) {
        console.warn(
          '[REPAIIR variant scope] "Show for variant" = "' +
            bad +
            '" does not match any variant on this product, so the section is hidden. ' +
            'Use a variant ID from Products > variant (the number at the end of the admin URL).',
          el,
        );
      }
    });

    // A section hidden for another variant can't be edited, so reveal whichever
    // one the merchant selects in the customizer.
    document.addEventListener('shopify:section:select', function (event) {
      var scoped = event.target.hasAttribute && event.target.hasAttribute(ATTR)
        ? event.target
        : event.target.querySelector('[' + ATTR + ']');
      if (scoped) scoped.removeAttribute(HIDDEN);
    });

    document.addEventListener('shopify:section:deselect', sync);
    document.addEventListener('shopify:section:load', sync);
  }
})();
